import { Principal } from '../application/authentication'
import { Policyholder } from './types'

export const isAuthenticated = (
  policyholder: Policyholder | undefined,
  principal: Principal,
): boolean =>
  principal.isAdmin ? !!policyholder?.accountRegistered : principal.isAuthenticated
